// extracted by mini-css-extract-plugin
export default {"root":"wfYeLT","main":"cYE3VF","asideHolder":"JBvPdB","aside":"_YSGhd"};